import React from 'react';
import { TrendingDown, ShieldAlert, Leaf, Globe, TrendingUp } from 'lucide-react';
export function ProblemSolution() {
  return <div className="w-full" data-id="element-133">
      {/* SECTION 1: EL GANCHO */}
      <section className="py-20 px-6 bg-earth text-bunker" data-id="element-134">
        <div className="max-w-4xl mx-auto" data-id="element-135">
          <div className="flex items-center gap-4 mb-8" data-id="element-136">
            <div className="h-px bg-pitahaya flex-1" data-id="element-137"></div>
            <span className="font-sans font-bold tracking-widest text-pitahaya uppercase text-sm" data-id="element-138">
              El Despertar
            </span>
            <div className="h-px bg-pitahaya flex-1" data-id="element-139"></div>
          </div>

          <h2 className="font-serif text-4xl md:text-5xl font-bold leading-tight mb-10 text-center" data-id="element-140">
            Si tienes tus ahorros en una cuenta bancaria tradicional en este
            momento, estás aceptando una{' '}
            <span className="text-pitahaya" data-id="element-141">
              pérdida silenciosa pero letal.
            </span>
          </h2>

          <div className="flex justify-center my-12" data-id="element-142">
            <div className="w-1 h-16 bg-bunker/20" data-id="element-143"></div>
          </div>

          <p className="font-sans text-xl leading-relaxed text-bunker/80 mb-6" data-id="element-144">
            Entre la inflación desbordada y la inestabilidad del dólar provocada
            por los conflictos en Estados Unidos, tu poder adquisitivo se está
            evaporando.
          </p>
          <p className="font-sans text-xl leading-relaxed text-bunker/80 font-medium" data-id="element-145">
            Ahorrar ya no es una virtud; es un riesgo que no puedes permitirte.
            Es hora de dejar de confiar en promesas bancarias y empezar a
            confiar en lo que es real:{' '}
            <strong className="text-bunker" data-id="element-146">La Tierra.</strong>
          </p>
        </div>
      </section>

      {/* SECTION 2: AGITACIÓN DEL DOLOR */}
      <section className="py-20 px-6 bg-bunker text-earth border-t border-white/10 relative overflow-hidden" data-id="element-147">
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 pointer-events-none" data-id="element-148">
          <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?q=80&w=2940&auto=format&fit=crop" alt="Stock market falling" className="w-full h-full object-cover mix-blend-luminosity" data-id="element-149" />
        </div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-150">
          <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-151">
            <div className="md:col-span-5" data-id="element-152">
              <ShieldAlert className="w-16 h-16 text-pitahaya mb-6" data-id="element-153" />
              <h2 className="font-serif text-4xl md:text-5xl font-bold leading-tight mb-6" data-id="element-154">
                ¿Qué valdrá tu dinero en 2027?
              </h2>
              <p className="font-sans text-lg text-earth/70 mb-4" data-id="element-155">
                ¿Seguirá alcanzando para tu jubilación o para el futuro de tus
                hijos?
              </p>
            </div>

            <div className="md:col-span-7 space-y-6" data-id="element-156">
              <p className="font-sans text-lg leading-relaxed text-earth/80" data-id="element-157">
                El sistema financiero actual está diseñado para que el ahorrador
                pierda. Cada vez que hay una crisis internacional en este año,
                el valor de tu esfuerzo tiembla en la pantalla de tu celular.
              </p>
              <div className="p-6 border border-white/10 bg-white/5" data-id="element-158">
                <p className="font-sans text-lg leading-relaxed text-earth/90" data-id="element-159">
                  Estás cansado de la incertidumbre. Estás harto de ver cómo los
                  precios suben mientras tus rendimientos bancarios son una
                  burla. El miedo a perderlo todo no es paranoia; es una señal
                  de que necesitas mover tu capital a un{' '}
                  <strong className="text-pitahaya" data-id="element-160">
                    Refugio de Valor (Safe Haven)
                  </strong>{' '}
                  que no dependa de algoritmos ni de decisiones políticas en
                  Washington.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: LA REVELACIÓN */}
      <section className="py-24 px-6 bg-forest text-earth" data-id="element-161">
        <div className="max-w-5xl mx-auto" data-id="element-162">
          <div className="text-center mb-16" data-id="element-163">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6" data-id="element-164">
              El Búnker Patrimonial
            </h2>
            <p className="font-sans text-xl text-earth/80 max-w-3xl mx-auto" data-id="element-165">
              La única forma de blindarte es regresar al origen. En tiempos de
              caos, el dinero fluye hacia los activos tangibles. Te presentamos
              el modelo de Crowdfarming de Pitahaya Investments.
            </p>
          </div>

          <div className="bg-bunker p-8 md:p-12 border border-pitahaya/30 mb-12" data-id="element-166">
            <p className="font-serif text-2xl md:text-3xl leading-relaxed text-center mb-0" data-id="element-167">
              No es solo tierra; es un Búnker de Producción. Al adquirir un lote
              productivo en Yucatán, estás haciendo el movimiento más
              inteligente de 2026: cambias una moneda que pierde valor por una
              planta biológica que aumenta su valor en tres dimensiones.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-168">
            <div className="bg-white/5 border border-white/10 p-8 hover:border-pitahaya transition-colors" data-id="element-169">
              <TrendingUp className="w-10 h-10 text-pitahaya mb-6" data-id="element-170" />
              <h3 className="font-sans font-bold text-xl mb-4" data-id="element-171">
                1. Plusvalía Real
              </h3>
              <p className="text-earth/70 leading-relaxed" data-id="element-172">
                Plusvalía real del estado más seguro de México. La tierra en
                Yucatán es un activo finito con demanda global creciente.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 p-8 hover:border-pitahaya transition-colors" data-id="element-173">
              <Leaf className="w-10 h-10 text-pitahaya mb-6" data-id="element-174" />
              <h3 className="font-sans font-bold text-xl mb-4" data-id="element-175">
                2. Crecimiento Físico
              </h3>
              <p className="text-earth/70 leading-relaxed" data-id="element-176">
                Crecimiento físico del activo. Tu inversión está viva; la planta
                de pitahaya crece cada día, aumentando su capacidad productiva.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 p-8 hover:border-pitahaya transition-colors" data-id="element-177">
              <Globe className="w-10 h-10 text-pitahaya mb-6" data-id="element-178" />
              <h3 className="font-sans font-bold text-xl mb-4" data-id="element-179">
                3. Rentas de Exportación
              </h3>
              <p className="text-earth/70 leading-relaxed" data-id="element-180">
                Rentas cobradas en mercados internacionales. Un escudo perfecto
                contra la devaluación local al generar ingresos en divisas
                fuertes.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}